module.exports = __webpack_public_path__ + "img/syukyaku-landing-ira001.7bb7a6be.png";